<template>
  <v-dialog max-width="1000" scrollable v-model="value" persistent>
    <v-card>
      <div class="text-xs-right">
        <v-btn fab small flat @click="onCancel"><v-icon>close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text max-height="600">
        <v-layout wrap>
          <v-flex xs12 sm6 md4 class="pa-1">
            <v-text-field
              label="Bot Origin"
              data-vv-as="Bot Origin"
              v-model="newbot.botorigin"
              v-validate="'required|excluded:' + botlist"
              name="botorigin"
              :hide-details="!errors.has('botorigin')"
              :error="errors.has('botorigin')"
              :error-messages="errors.first('botorigin')"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 class="pa-1">
            <v-text-field
              label="Bot Name"
              data-vv-as="Bot Name"
              v-model="newbot.botname"
              v-validate="{ required: true }"
              name="botname"
              :hide-details="!errors.has('botname')"
              :error="errors.has('botname')"
              :error-messages="errors.first('botname')"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 class="pa-1">
            <v-text-field
              label="Bot Theme"
              data-vv-as="Bot Theme"
              v-model="newbot.bottheme"
              v-validate="'required'"
              name="bottheme"
              :hide-details="!errors.has('bottheme')"
              :error="errors.has('bottheme')"
              :error-messages="errors.first('bottheme')"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex xs12 class="pa-1">
            <v-radio-group v-model="newbot.isline" row>
              <v-radio label="Facebook" color="primary" :value="false"></v-radio>
              <v-radio label="Line" color="primary" :value="true"></v-radio>
            </v-radio-group>
            <div style="border: 1px solid #eee;border-radius: 5px;">
              <div class="pa-3" v-if="!newbot.isline">
                <div class="title mb-2">Facebook</div>
                <v-text-field
                  label="Page Access Token"
                  data-vv-as="Page Access Token"
                  v-model="newbot.page_access_token"
                  name="page_access_token"
                  :hide-details="!errors.has('page_access_token')"
                  :error="errors.has('page_access_token')"
                  :error-messages="errors.first('page_access_token')"
                  outline
                ></v-text-field>
              </div>

              <div class="pa-3" v-else>
                <div class="title mb-2">Line</div>

                <template v-if="newbot.botorigin">
                  Webhook URL:
                  <span class="text-primary">{{ lineWebhookUrl }}</span>
                  <!-- copy webhook URL -->
                  <!-- copy to clipboard and show tooltip -->
                  <v-btn class="ml-2" small color="primary" @click="onCopyWebhookUrl">Copy</v-btn>
                </template>

                <v-text-field
                  label="Channel Secret"
                  data-vv-as="Channel Secret"
                  class="mb-1"
                  v-model="newbot.channelsecret"
                  outline
                  v-validate="newbot.isline == true ? 'required' : ''"
                  name="channelsecret"
                  :hide-details="!errors.has('channelsecret')"
                  :error="errors.has('channelsecret')"
                  :error-messages="errors.first('channelsecret')"
                ></v-text-field>

                <v-text-field
                  label="Access Token"
                  data-vv-as="Access Token"
                  class="mb-1"
                  v-model="newbot.accesstoken"
                  outline
                  v-validate="newbot.isline == true ? 'required' : ''"
                  name="accesstoken"
                  :hide-details="!errors.has('accesstoken')"
                  :error="errors.has('accesstoken')"
                  :error-messages="errors.first('accesstoken')"
                ></v-text-field>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
export default {
  props: ['value', 'bots', 'page'],
  data() {
    return {
      newbot: {
        botorigin: null,
        botstatus: true,
        botname: null,
        bottheme: 'dragdrop',
        page_access_token: null,
        isline: false,
        accesstoken: null,
        channelsecret: null
      }
    }
  },
  mounted() {
    if (this.page) {
      this.newbot = this.page
    }
  },
  computed: {
    botlist() {
      var vm = this
      return this.bots
        .map(el => {
          return el.botorigin.trim().toLowerCase()
        })
        .filter(el => {
          if (vm.page && vm.page.botorigin)
            return el.toLowerCase() != vm.page.botorigin.toLowerCase()
          else return true
        })
        .join(',')
    },
    lineWebhookUrl() {
      return (
        'https://tunejaiproject.herokuapp.com/webhookline?botorigin=' +
        (this.newbot.botorigin ? this.newbot.botorigin : '')
      )
    }
  },
  methods: {
    onCancel() {
      this.$emit('input', false)
      this.newbot = {
        botorigin: null,
        botstatus: true,
        botname: null,
        bottheme: 'dragdrop',
        page_access_token: null,
        isline: false,
        accesstoken: null,
        channelsecret: null
      }
      this.errors.clear()
      this.$emit('onCancel')
    },
    async onSave() {
      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        return false
      }

      var response = await this.addBotOrigin()

      if (response.data && response.data.length > 0) {
        await this.$swal.fire({
          type: 'success',
          title: this.$t('Success')
        })
        this.$emit('input', false)
        this.$emit('saveBot', response.data[0])
        await this.$store.dispatch('loadAllBotOrigins')
        await this.$nextTick()
        if (this.page) {
          this.newbot = this.page
        } else {
          this.newbot = {
            botorigin: null,
            botstatus: true,
            botname: null,
            bottheme: 'dragdrop',
            page_access_token: null,
            isline: false,
            accesstoken: null,
            channelsecret: null
          }
        }
        this.errors.clear()
      }
    },
    async copyTextToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text)
        console.log('Text copied to clipboard successfully!')
      } catch (err) {
        console.error('Error copying text to clipboard:', err)
        throw new Error('Failed to copy text to clipboard: ' + err)
      }
    },
    onCopyWebhookUrl() {
      this.copyTextToClipboard(this.lineWebhookUrl).then(
        () => {
          this.$swal.fire({
            type: 'success',
            title: this.$t('Copied to clipboard')
          })
        },
        () => {
          this.$swal.fire({
            type: 'error',
            title: this.$t('Failed to copy')
          })
        }
      )
    },
    addBotOrigin() {
      var data = {
        ...this.newbot
      }

      return new Promise((resolve, reject) => {
        api.addbotorigin(data, function(error, response) {
          if (error) {
            reject(error)
          }

          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/AddBot.vue